module.exports = __webpack_public_path__ + "static/media/27_tn.b6e58090.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/27_tn.jpg
// module id = 241
// module chunks = 0